export const config = {
    apiURL: process.env.NODE_ENV === "development" ? 'https://www.myprimerenov.fr/api' : 'https://www.myprimerenov.fr/api',
    //apiURL: 'http://172.105.81.232:7001/',
}